/* Package JSON Import will be here */
import { forEach } from 'lodash';
/* Package JSON Import will be here */

/* Project Import will be here */
import { getErrorObject } from "../../utilities/utils";
import { getStaticContentListApi } from "services/common/staticContent";
import { IStaticContentParams } from "models/commonModels";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    STATIC_CONTENT_LIST_REQUEST: "staticContent/staticContentRequest",
    STATIC_CONTENT_LIST_SUCCESS: "staticContent/staticContentSuccess",
    STATIC_CONTENT_LIST_FAILURE: "staticContent/staticContentFailure",
};

let initialState = {
    isLoading: false,
    minOrderQtyDisclaimer: null,
    termsAndCondition: [],
    contractAgreement: null,
    smartListDisclaimer: null,
    error: null
};

export const staticContent = (state = initialState, action) => {
    switch (action.type) {
        case types.STATIC_CONTENT_LIST_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.STATIC_CONTENT_LIST_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };
        case types.STATIC_CONTENT_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        default:
            return state;
    }
};

/* Get static content list */
export const getStaticContentList = (token = null) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.STATIC_CONTENT_LIST_REQUEST });
        try {
            const requestObject: IStaticContentParams = {
                Code: Constants.APP_CONTENT_TEMPLATE
            };
            const response = await getStaticContentListApi(requestObject, token);

            let responseConfigObject = { termsAndCondition: [] };

            forEach(response.data.Data, (o) => {
                switch (o.Key) {
                    case 'MinOrderQtyDisclaimer':
                        responseConfigObject.minOrderQtyDisclaimer = JSON.parse(o.Value);
                        break;
                    case 'TermsAndCondition':
                        responseConfigObject.termsAndCondition.push({ lang: o.LangCode, value: JSON.parse(o.Value) });
                        break;
                    case 'ContractAgreement':
                        responseConfigObject.contractAgreement = JSON.parse(o.Value);
                        break;
                    case 'SmartListDisclaimer':
                        responseConfigObject.smartListDisclaimer = JSON.parse(o.Value);
                        break;
                    default:
                        break;
                }
            });

            dispatch({
                type: types.STATIC_CONTENT_LIST_SUCCESS,
                payload: responseConfigObject
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.STATIC_CONTENT_LIST_FAILURE,
                payload: { error: message }
            });
        }
    }
};